import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Reservations from "@/pages/Reservations";
import Products from "@/pages/Products";
import POS from "@/pages/POS";
import Revenue from "@/pages/Revenue";
import Rooms from "@/pages/Rooms";
import Partners from "@/pages/Partners";
import RetreatDetail from "@/pages/RetreatDetail";
import RetreatBill from "@/pages/RetreatBill";
import Leads from "@/pages/Leads";
import RetreatPlanner from "@/pages/RetreatPlanner";
import Kitchen from "@/pages/Kitchen";
import Bill from "@/pages/Bill";
import Login from "@/pages/Login";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/bill/:id" element={<Bill />} />
          <Route path="/retreat-bill/:id" element={<RetreatBill />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/reservations" element={<Reservations />} />
            <Route path="/products" element={<Products />} />
            <Route path="/pos" element={<POS />} />
            <Route path="/revenue" element={<Revenue />} />
            <Route path="/rooms" element={<Rooms />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/leads/calendar" element={<RetreatPlanner />} />
            <Route path="/kitchen" element={<Kitchen />} />
            <Route path="/retreats/:id" element={<RetreatDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
